import React from 'react';
import PropTypes from 'prop-types';
import Panel from 'wonderbly-components/lib/Panel';
import Button from 'wonderbly-components/lib/Button';
import LineItem from '../../CartItems/LineItem';
import { date } from 'src/common/utils/date-time-formatter';
import { Row, Col } from 'wonderbly-components/lib/Grid';
import cx from 'classnames';

const UserOrder = props => {
  const userOrderInfo = (
    <div className="user-order-info">
      {props.order.completedAt && (
        <span className="user-order-date">
          {date(props.order.completedAt, props.country)}
        </span>
      )}
      {props.order.total && (
        <span className="user-order-price">
          {props.order.total.formatted}
        </span>
      )}
    </div>
  );

  return (
    <div
      className={cx('user-order', {
        'user-order--list': !props.isSingleOrder,
        'user-order--cancelled': props.order.isCancelled,
      })}>
      {props.isSingleOrder && userOrderInfo}
      <Row className="user-order-header" colsToRowsOn="fablet-down">
        {!props.isInactiveOrders && props.orderStatus && (
          <Col><div className="user-order-status">{props.orderStatus}</div></Col>
        )}
      </Row>
      <div className="user-order-items">
        {(props.order.items || []).map(item => (
          <Panel key={item.id} border="shadow" className="user-order-item">
            <LineItem
              item={item}
              editItemCta={'Edit book'}
              isEditable={props.isEditable}
              isCustomisationsExpanded={props.isSingleOrder}
              orderNumber={props.order.id}
            />
          </Panel>
        ))}
      </div>
      {!props.isSignedIn && props.isSingleOrder && (
        <div className="aligned-center">
          <p>{props.loginToEdit}</p>
          <Button href={props.loginUrl}>{props.loginToEditCta}</Button>
        </div>
      )}
      <div className="user-order-footer">
        {props.isInactiveOrders && userOrderInfo}
        {!props.isSingleOrder && (
          <Button href={props.viewOrderUrl}>{props.viewOrderText}</Button>
        )}
      </div>
    </div>
  );
};

UserOrder.propTypes = {
  editableSecondsRemaining: PropTypes.string,
  country: PropTypes.object.isRequired,
  order: PropTypes.shape({
    id: PropTypes.string,
    completedAt: PropTypes.string,
    isCancelled: PropTypes.bool,
    isOpen: PropTypes.bool,
    total: PropTypes.shape({
      formatted: PropTypes.string,
    }),
    items: PropTypes.array,
    editableSecondsRemaining: PropTypes.number,
  }),
  orderStatus: PropTypes.string,
  isSingleOrder: PropTypes.bool,
  isEditable: PropTypes.bool.isRequired,
  isSignedIn: PropTypes.bool.isRequired,
  loginUrl: PropTypes.string.isRequired,
  loginToEdit: PropTypes.string,
  loginToEditCta: PropTypes.string,
  viewOrderUrl: PropTypes.string,
  viewOrderText: PropTypes.string,
  isInactiveOrders: PropTypes.bool,
  timeRemaining: PropTypes.string,
};

export default UserOrder;



// WEBPACK FOOTER //
// ./src/client/js/view/components/UserOrders/UserOrder/UserOrder.js